// import { useEffect } from "react";
import { Config, IISMethods } from 'config/IISMethods'
import { store } from '..'
import { setLoadings, setProps } from 'redux/actions'
import { useDispatch } from "react-redux";

const useService = () => {
    const dispatch = useDispatch()
    const getCurrentState = () => store.getState()
    const getInfoState = () => store.getState()['info']

    // for loader
    const addLoaders = async (key, value) => {
        if (value === 1) getCurrentState().loadings[key] = value
        else delete getCurrentState().loadings[key]
        await dispatch(setLoadings({ loadings: IISMethods.getCopy(getCurrentState().loadings) }))
    }

    const getParams = () => {
        let url = window.location.pathname
        let params = url.split('/').filter(p => p && !['verifyotp', 'unlockdoor', 'linkexpired'].includes(p))
        let pre = params[0] || '', cid = params[1] || '', ra = params[2] || ''
        return { pre, cid, ra }
    }

    const getURLData = () => {
        let params = getParams()
        let pre = params?.pre || '', cid = params?.cid || '', ra = params?.ra || ''
        return { defaultURL: [pre, cid, ra].filter(Boolean).join('/') }
    }

    const getLocalDataURL = () => {
        let params = getParams()
        let pre = params?.pre || '', cid = params?.cid || ''
        return { defaultURL: [pre, cid].filter(Boolean).join('/') }
    }

    const getStorageData = (key) => {
        let accessData = IISMethods.getLocalData("DigitalkeyData") || {}
        let data = accessData[getURLData().defaultURL] || {}
        return Object.keys(data).length > 0 ? data[key] : null
    }

    const clearStorageData = async () => {
        let accessData = IISMethods.getLocalData("DigitalkeyData") || {}
        const urlKey = getURLData().defaultURL
        if (accessData[urlKey]) {
            delete accessData[urlKey]
        }
        await IISMethods.setLocalData("DigitalkeyData", accessData)
    }

    const setStorageData = async (key, data) => {
        let accessData = await IISMethods.getLocalData("DigitalkeyData") || {}
        if (!accessData[getURLData().defaultURL]) {
            accessData[getURLData().defaultURL] = {}
        }
        accessData[getURLData().defaultURL][key] = data
        await IISMethods.setLocalData("DigitalkeyData", accessData)
    }

    const setAllStorageData = async (key, data, accessDataKey) => {
        let accessData = await IISMethods.getLocalData("DigitalkeyData") || {};
        let matchedDigitalKeys = []
        if (accessDataKey === 'reservationdata') {
            matchedDigitalKeys = accessData[getURLData().defaultURL]?.[accessDataKey]
                ?.flatMap(res => res.keyaccessguestdetails || [])
                .filter(
                    guest =>
                        `+${guest.countrycode}${guest.phoneno}` ===
                        accessData[getURLData().defaultURL]?.digitalkeydata?.fullcontact
                )
                .map(guest => {
                    // extract last 3 parts
                    let parts = guest.digitalkey.split("/");
                    return parts.slice(-3).join("/");
                });
        } else if (accessDataKey === 'onetimekeydata' || accessDataKey === 'areadashboarddata') {
            matchedDigitalKeys = accessData[getURLData().defaultURL]?.[accessDataKey]
                .map(guest => {
                    // extract last 3 parts
                    let parts = guest.digitalkey.split("/");
                    return parts.slice(-3).join("/");
                });
        }
        matchedDigitalKeys?.forEach(keySuffix => {
            // ensure the object exists
            if (!accessData[keySuffix]) {
                accessData[keySuffix] = {};
            }

            accessData[keySuffix][key] = data;
        });

        await IISMethods.setLocalData("DigitalkeyData", accessData);
    };

    const getAccessToken = async (keyName) => {
        const url = Config.weburl + 'getaccesstoken'
        const reqData = {}
        let headers = {
            key: Config.APP_KEY,// "Kiosist_98F2B6E0-240A-457B-853A-A0079862315F", comment  Heli 30/10/2023 05:40 
            issuer: "website",
            'user-agent': window.navigator.userAgent
        }
        if (Config.encryptdata) { headers = { reqheader: IISMethods.encryptData(headers) } }

        await IISMethods.axiosrequest("POST", url, reqData, headers, successCallback, errorCallback)
        var resp

        function successCallback(response) {
            if (Config.encryptdata) {
                resp = response || {}
                resp.data = JSON.parse(JSON.parse(IISMethods.decryptData(response.data)))
                resp.headers = JSON.parse(JSON.parse(IISMethods.decryptData(response.headers.resheader)))
            }
            else { resp = response }
        }

        function errorCallback(error) {
            if (Config.encryptdata) {
                resp = error
                resp.data = JSON.parse(JSON.parse(IISMethods.decryptData(error.response.data)))
                resp.headers = JSON.parse(JSON.parse(IISMethods.decryptData(error.response.headers)))
            }
            else { resp = error }
        }

        if (resp.status === 200) {
            let obj = {}
            // let shortid = IISMethods.getQueryObj()
            let localData = IISMethods.getLocalData('DigitalkeyData')
            obj.subdomainname = localData[keyName]?.subdomainname
            if (localData[keyName]?.bookingid !== Config.dummyid) {
                obj.bookingid = localData[keyName]?.bookingid
            }

            else if (localData[keyName]?.areaid !== Config.dummyid) {
                obj.areaid = localData[keyName]?.areaid
            }

            else if (localData[keyName]?.bookingid === Config.dummyid && localData[keyName]?.isonetimekey === 1) {
                obj.isonetimekey = 1
            }

            // obj.bookingid = localData[keyName]?.bookingid
            // in this localData[keyName]?.bookingid !== Config.dummyid then obj.bookingid , if localData[keyName]?.areaid !== Config.dummyid then key obj.areaid and if  bookingid is dummy but onetimekey = 1 then obj.isonetimekey
            obj.querystring = getQueryString(localData[keyName])
            // obj.querystring = getQueryString()
            obj.token = resp.headers.token
            obj.unqkey = resp.data.data.unqkey
            obj.uid = resp.data.data.uid
            obj.step = 0
            //if booking id is match and cookies has already fbtoken then default set because 
            // if cookie has fbtoken then again add device not called JENIL 21/8/2023 11:30 AM
            let cookiedata = IISMethods.getGuestInfo()
            if (cookiedata.bookingid === getInfoState().reservation.bookingid && cookiedata.fbtoken) {
                obj['fbtoken'] = cookiedata.fbtoken
            }
            IISMethods.setCookiesData(Config.cookiestorage['loginInfo'], IISMethods.getCopy(obj))
            // }
        }
        else {
            localStorage.clear()
        }
    }

    const getQueryString = (keyname) => {
        const bookingid = keyname['bookingid']
        const subdomainname = keyname['subdomainname']
        const areaid = keyname['areaid']
        const isonetimekey = keyname['isonetimekey']
        let queryStr = `?subdomainname=${subdomainname}`

        // If bookingid is not dummy → use bookingid
        if (bookingid !== Config.dummyid) {
            queryStr += `&bookingid=${bookingid}`
        }
        // If areaid is not dummy → use areaid
        else if (areaid !== Config.dummyid) {
            queryStr += `&areaid=${areaid}`
        }
        // If bookingid is dummy but onetimekey = 1 → use onetimekey
        else if (bookingid === Config.dummyid && isonetimekey === 1) {
            queryStr += `&isonetimekey=1`
        }
        return queryStr
    }

    const handleGrid = async (id, type, key, value) => {
        if (type === 'modal') {
            if (value) {
                getCurrentState().modal[key] = id
            }
            else {
                delete getCurrentState().modal[key]
            }
            await dispatch(setProps({ modal: IISMethods.getCopy(getCurrentState().modal) }))
        }
        else { }
    }

    const hasExactlyOneLengthOne = (Data = null) => {
        let localData = IISMethods.getLocalData('DigitalkeyData')
        let ResultData = Data !== null ? Data : localData[getURLData().defaultURL]
        const keys = ['reservationdata', 'areadashboarddata', 'onetimekeydata'];

        const lengths = keys.map(key => {
            // check camelCase first
            if (Array.isArray(ResultData[key])) return ResultData[key].length;

            // check PascalCase
            const pascalKey = key.charAt(0).toUpperCase() + key.slice(1);
            if (Array.isArray(ResultData[pascalKey])) return ResultData[pascalKey].length;

            return 0;
        });

        const countOne = lengths.filter(len => len === 1).length;
        const countZero = lengths.filter(len => len === 0).length;

        return countOne === 1 && countZero === 2;
    };

    const removeRoomData = async (roomnoid) => {
        const RoomLockData = getStorageData('roomlockdata')
        const ReservationData = getStorageData('reservationdata')
        const OneTimekeyData = getStorageData('onetimekeydata')
        const AreaLockData = getStorageData('arealockdata')
        // 1. Filter reservationdata
        const newReservationData = ReservationData?.filter(r => r.roomnoid !== roomnoid);

        // 2. Filter onetimekeydata
        const newOnetimeKeyData = OneTimekeyData?.filter(k => k.roomnoid !== roomnoid);

        // 3. Filter roomlockdata by groupid
        const newRoomLockData = RoomLockData?.filter(r => r.groupid !== roomnoid);

        // 4. Update arealockdata lockdata.roomnoid arrays
        const newAreaLockData = AreaLockData
            .map(area => {
                // Check if any lockdata has roomnoid length === 1 and contains roomnoid
                const removeWholeGroup = area.lockdata.some(lock => lock.roomnoid?.length === 1 && lock.roomnoid[0] === roomnoid);
                if (removeWholeGroup) return null; // remove entire area group

                // Otherwise, remove roomnoid from lockdata arrays
                const updatedLockData = area.lockdata.map(lock => ({
                    ...lock,
                    roomnoid: lock.roomnoid ? lock.roomnoid.filter(id => id !== roomnoid) : []
                }));

                return { ...area, lockdata: updatedLockData };
            })
            .filter(Boolean); // remove nulls

        const updatedDataMap = {
            RoomlockData: newRoomLockData,
            ArealockData: newAreaLockData,
            OnetimekeyData: newOnetimeKeyData,
            ReservationData: newReservationData
        };

        const storageKeys = ['reservationdata', 'onetimekeydata', 'areadashboarddata'];

        for (const key of storageKeys) {
            await setAllStorageData('roomlockdata', newRoomLockData, key);
            await setAllStorageData('arealockdata', newAreaLockData, key);
            await setAllStorageData('onetimekeydata', newOnetimeKeyData, key);
            await setAllStorageData('reservationdata', newReservationData, key);
        }
        getCurrentState().linkData = {
            ...getCurrentState().linkData,
            ...updatedDataMap
        };
        await dispatch(setProps({ linkData: IISMethods.getCopy(getCurrentState().linkData) }))

        // 4. Update storage for all keys
    };

    const getCheckInTime = (checkintime = '') => {
        const utcDate = checkintime
        let utcTime = "1970-01-01T00:00:00.000Z";

        const dateObj = IISMethods.GetDT(utcDate);
        const timeObj = IISMethods.GetDT(utcTime);

        const hours = dateObj.getUTCHours();
        const minutes = dateObj.getUTCMinutes();
        const seconds = dateObj.getUTCSeconds();

        timeObj.setUTCHours(hours, minutes, seconds)
        return timeObj.toISOString() || '-'
    }


    const isblacklistCheck = () => {
        const AreaLockData = getStorageData('arealockdata');
        const RoomLockData = getStorageData('roomlockdata')
        const roomHasBlacklist = RoomLockData?.some(item => item.isblacklist === 1);
        const areaHasBlacklist = AreaLockData?.some(item => item.isblacklist === 1);
        return roomHasBlacklist || areaHasBlacklist || false;
    };

    return { getStorageData, setStorageData, getURLData, getParams, getQueryString, getAccessToken, handleGrid, addLoaders, clearStorageData, getLocalDataURL, setAllStorageData, hasExactlyOneLengthOne, removeRoomData, getCheckInTime, isblacklistCheck}
}

export default useService;






